import { tokenKey } from '../utils/org-slug'

type AuthSessionListener = () => void

const listeners = new Set<AuthSessionListener>()

export function onAuthSessionExpired(listener: AuthSessionListener): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export function clearAuthTokens(): void {
  localStorage.removeItem(tokenKey('accessToken'))
  localStorage.removeItem(tokenKey('refreshToken'))
  localStorage.removeItem('token')
}

export function invalidateAuthSession(): void {
  clearAuthTokens()
  for (const listener of listeners) {
    listener()
  }
}
